import { render, staticRenderFns } from "./Pinnedhistory.vue?vue&type=template&id=4d053ea4&scoped=true"
import script from "./Pinnedhistory.vue?vue&type=script&lang=js"
export * from "./Pinnedhistory.vue?vue&type=script&lang=js"
import style0 from "./Pinnedhistory.vue?vue&type=style&index=0&id=4d053ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d053ea4",
  null
  
)

export default component.exports